// 后台接口地址统一出口（全项目唯一）
// 唯一变量源：config/*.env.js 中的 BACKEND_API_HOST（形如 "poto.jotopic.com/api"，不含协议头与结尾斜杠）
// 切换生产/测试环境只需修改对应 env 文件的 BACKEND_API_HOST，其余全部自动派生。

const HOST = process.env.BACKEND_API_HOST

// 协议自适应：页面运行在 https 下时使用 https，避免混合内容(mixed-content)被浏览器拦截
function resolveProtocol () {
  if (typeof window !== 'undefined' && window.location && window.location.protocol === 'https:') {
    return 'https:'
  }
  return 'http:'
}

// 后台接口基础地址，结尾带斜杠
// 若 BACKEND_API_HOST 以 / 开头，视为"同源相对路径"：浏览器请求当前域名下的该路径，
// 由 nginx 等反向代理转发到本机后端，避免"本机→公网→回本机"的绕行；外网访问同样经同源反代到达后端。
// 否则按绝对主机处理，例如 http://poto.jotopic.com/api/
export const API_BASE = HOST.indexOf('/') === 0
  ? HOST.replace(/\/+$/, '') + '/'
  : `${resolveProtocol()}//${HOST}/`

// 去掉结尾斜杠的基础地址，用于拼接图片相对路径等场景
export const API_ORIGIN = API_BASE.replace(/\/$/, '')

// 通用文件上传地址
export const UPLOAD_URL = `${API_BASE}file/upload`

export default {
  API_BASE,
  API_ORIGIN,
  UPLOAD_URL
}



// WEBPACK FOOTER //
// ./src/utils/apiConfig.js